import Dexie from 'dexie';
import 'dexie-observable';
import { uploadPendingFileFromIndexedDB } from './image-manip-helpers';
import { builderDispatch, WebUI } from '../ui';
import { usePrismItemStore } from 'stores/usePrismItemStore';

/**
 * Represents the database instance for LIVELINK_PRISM_BUILDER.
 * @type {Dexie}
 */
export const db = new Dexie('LIVELINK_PRISM_BUILDER');
db.version(1).stores({
  upload: '$$uuid, status, prismItemID',
});

db.on('changes', function(changes) {
  changes.forEach(async function(change) {
    switch (change.table) {
      case 'upload':
        if (prismItem.num !== change.obj?.prismItemID) {
          return;
        }

        switch (change.type) {
          case 1: // CREATED
            await uploadPendingFileFromIndexedDB(change.obj.uuid);
            break;
          case 2: // UPDATED
            builderDispatch.dispatch({
              type: WebUI.UPLOAD_PROGRESS,
            });
            usePrismItemStore.getState().trackProgress();
            break;
        }
        break;
    }
  });
});
